import { FormDuufGroup, FormDuufSubmit } from '@ubo/form-duuf'
import { useLocation, useNavigate } from '@ubo/losse-sjedel'
import { useEffect, useState } from 'react'
import Content from '~/components/elements/Content'
import Form from '~/components/elements/Form'
import Loading from '~/components/elements/Loading'
import type { Page_Flexcontent_Flex_Text, Page_Flexcontent_Flex_Vacancies } from '~/graphql/types'

export default function OpenSollicitation({ fields }: { fields: Page_Flexcontent_Flex_Vacancies | Page_Flexcontent_Flex_Text }) {
  const location = useLocation()
  const navigate = useNavigate()
  const [show, setShow] = useState(false)

  useEffect(() => {
    if (location.hash !== '#opensollicitatie') {
      setShow(false)
    } else {
      setShow(true)
    }
  }, [location])

  if (!show) return null

  return (
    <section
      onClick={() => {
        navigate('#', {
          state: {
            scroll: false
          }
        })
        setShow(false)
      }}
      className="bg-black/50 cursor-pointer fixed h-full w-full top-0 left-0 z-50 flex justify-center items-center"
      id="OpenSollicitation"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white relative flex flex-col gap-3 max-w-[1024px] lg:min-w-[500px] p-6 md:p-10 cursor-auto shadow"
      >
        <div className="absolute top-6 right-6">
          <svg
            onClick={() => {
              navigate('#', {
                state: {
                  scroll: false
                }
              })
              setShow(false)
            }}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#000000"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-x cursor-pointer"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </div>
        <div>
          <Content className="text-lm-shoe children-h2:text-3xl md:children-h2:text-5xl pb-5 md:pb-10">
            {fields.opensollicitation?.formdescription}
          </Content>
          <Form
            data={fields.opensollicitation?.form}
            generate={false}
            privacyUrl="/privacyverklaring/"
            privacyUrlPlacement="Privacy Voorwaarden"
            renderLoading={() => <Loading />}
            renderStatus={({ status, content }) => <Content className="text-black pt-5">{content}</Content>}
          >
            <div>
              <div className="grid grid-cols-2 gap-x-11">
                <FormDuufGroup showIds={[1, 3]} />
              </div>
              <FormDuufGroup showIds={[4, 5, 6, 7, 8]} />
              <div className="flex justify-end">
                <FormDuufSubmit />
              </div>
            </div>
          </Form>
        </div>
      </div>
    </section>
  )
}
